import { TextField, InputAdornment, IconButton, CircularProgress } from "@mui/material";
import React, { useContext, useRef } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { api, IAssetVehicleDVLAResult, RequestStatus } from "../../../../logic/api";

import { useEffect } from "react";
import { EditableGroupContext } from "../../EditableGroup/EditableGroup";
import { SessionContext } from "../../../../utility/useSession";

const DVLAField: React.FunctionComponent<{
    label?: string;
    value?: string;
    testId?: string;
    onChange: (value: IAssetVehicleDVLAResult | string) => void;
}> = (props) => {
    const session = useContext(SessionContext);
    const dvlaHook = api.hooks.assetVehicle.dvlaLookup();


    const groupContext = useContext(EditableGroupContext);
    const ref = useRef<HTMLInputElement>();
    useEffect(() => {
        if (ref.current) {
            ref.current.value = props.value || "";
        }
    }, [groupContext.buildId]);


    const doLookup = () => {
        if (ref.current) {
            if (ref.current.value.length == 0) {
                ref.current.focus();
                return;
            }
            dvlaHook.send(session.current.context, {
                registration: ref.current.value
            }, (result) => {
                props.onChange(result as IAssetVehicleDVLAResult);
            });
        }
    };

    return (
        <TextField
            data-testid={props.testId ? `${props.testId}-container` : undefined}
            label={props.label}
            type="text"
            size="small"
            style={{ maxWidth: 225 }}
            variant="outlined"
            inputRef={ref}
            value={props.value || ""}
            onChange={(e) => {
                props.onChange(e.target.value);
            }}
            onKeyDown={(e) => {
                if (e.key == "Enter") {
                    e.preventDefault();
                    doLookup();
                    return false;
                }
            }}
            slotProps={{
                htmlInput: {
                    "data-testid": props.testId
                }
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position={"end"}>
                        {dvlaHook.status == RequestStatus.loading ? <CircularProgress size={20} /> : <IconButton style={{ padding: 0, width: "auto", height: "auto" }} onClick={() => doLookup()} data-testid={props.testId ? `${props.testId}-search-button` : undefined}>
                            <SearchIcon />
                        </IconButton>
                        }
                    </InputAdornment>
                )
            }}
        />
    );
}

export default DVLAField;